import { THEME_PRESETS } from "@app/core";
import { cn } from "@app/ui";
import { preloadPaletteBoardForPreset } from "../../../palettePicker/index.js";
import { useI18n } from "../../../lib/useI18n.js";
import { useThemeStore } from "../../../stores/theme.store.js";

/** The curated aesthetic presets (+ a "Custom" chip when the active theme isn't
 *  one of them). Each card shows the theme's own palette + vibe + light/dark
 *  mode; selecting it rebuilds the theme and adopts its natural mode. */
export function ThemePresetPicker() {
  const { t } = useI18n();
  const preset = useThemeStore((s) => s.config.preset);
  const setPreset = useThemeStore((s) => s.setPreset);
  const isCustom = !THEME_PRESETS.some((p) => p.id === preset);

  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {THEME_PRESETS.map((p) => {
        const active = p.id === preset;
        return (
          <button
            key={p.id}
            type="button"
            onClick={() => setPreset(p.id)}
            onFocus={() => preloadPaletteBoardForPreset(p.id)}
            onPointerEnter={() => preloadPaletteBoardForPreset(p.id)}
            className={cn(
              "flex flex-col gap-2 rounded-lg border p-3 text-left transition-colors",
              active ? "border-primary ring-2 ring-primary" : "border-border hover:bg-accent",
            )}
          >
            <div className="flex items-center justify-between gap-2">
              <span className="text-sm font-medium">{p.name}</span>
              <span className="rounded-full border border-border px-2 py-0.5 text-[calc(10px*var(--app-text-scale))] uppercase text-muted-foreground">
                {p.defaultMode === "dark" ? t("theme.mode.dark") : t("theme.mode.light")}
              </span>
            </div>
            <span className="flex h-5 w-full overflow-hidden rounded">
              {p.entityPalette.slice(0, 10).map((hex, i) => (
                <span key={i} className="h-full flex-1" style={{ background: hex }} />
              ))}
            </span>
            <span className="text-xs text-muted-foreground">{p.description}</span>
          </button>
        );
      })}
      {isCustom && (
        <span className="flex items-center justify-center rounded-lg border border-primary p-3 text-sm ring-2 ring-primary">
          {t("theme.custom")}
        </span>
      )}
    </div>
  );
}
